import MyBread from '../../components/Breadcrumbs'
import React, { useEffect, useState, Dispatch, SetStateAction } from 'react'
import MaterialTable from 'material-table'
import { ThemeProvider, createTheme } from '@mui/material';
import { useAuth } from '../../hooks/use-auth';
import axios from 'axios';
import { Wrapper, PageTitle } from 'styles/styles';

interface ParentProps {
	data: ParentDataProps[];
	setIsParentDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface ParentDataProps {
	equipment_id: string
	color_code: string
	name: string
	name_kana: string
	abbreviation: string
	available_time: number
	status: string
	memo: string
}


const Parent = ({ data, setIsParentDataInsert }: ParentProps) => {
	const auth = useAuth();

	//arrayの生成

	const parentArray = [
		{ title: '', field: 'process_id' },
		{ title: '', field: 'supplier_factory_id' },
		{ title: '連携済仕入先ID', field: 'supplier_display_id' },
		{ title: '連携済仕入先名前', field: 'supplier_name' },
		{ title: '製作数量', field: 'order_number' },
		{ title: '依頼納期', field: 'internal_deadline' },
		{ title: '依頼工程名', field: 'product_name' },
		{ title: '工程完了数', field: 'completed_number' },
		{ title: '工程未完了数', field: 'not_completed_number' },
		{ title: '依頼時工場名', field: 'customer_factory_name' },
		{ title: 'メモ', field: 'memo' },
		{ title: 'status', field: 'status' }
	]
	const PAGE_TITLE = "共有工程"
	const columnsArray: any = [];
	for (const element of parentArray) {
		if (element.title) {
			columnsArray.push({
				title: element.title,
				field: element.field,
				cellStyle: {
					minWidth: 150,
					maxWidth: 150,
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis'
				}
			})
		}
	}
	//カラムなど生成ここまで

	const defaultMaterialTheme = createTheme();
	const [pageSize, setPageSize] = React.useState(5);


	return (
		<>
			<ThemeProvider theme={defaultMaterialTheme}>
				<MaterialTable
					title={PAGE_TITLE}
					columns={columnsArray}
					data={data}
					actions={[
						rowData => ({
							icon: 'delete',
							tooltip: '削除する',
							hidden: !(rowData.status === '依頼進行中' || rowData.status === '新規依頼中'),
							onClick: async (event, rowData: any) => {
								event.preventDefault();
								const result = window.confirm(`削除しますか？`);
								if (result) {
									try {
										const branchData = {
											supplier_factory_id: rowData.supplier_factory_id,
											process_id: rowData.process_id,
											action: 'delete'
										}
										await axios.patch(`/v0/factories/${auth.factoryId}/share-processes`, branchData, {
											headers: auth.authorizationHeader
										});
										setIsParentDataInsert(true);
									} catch (error: any) {
										window.alert(error.response.data.error)
									}
								}
							}
						})
					]}
					options={{
						actionsColumnIndex: -1,
						headerStyle: { whiteSpace: 'nowrap' },
						rowStyle: { overflowWrap: 'break-word' }
					}}
					onChangeRowsPerPage={(pageSize) => {
						setPageSize(pageSize);
					}}
					onRowClick={(event: any, rowData: any) => {
						event.preventDefault();
					}}
				/>
			</ThemeProvider>
		</>
	)
}

export default function ProcessesRequest() {
	const auth = useAuth();
	const [isParentDataInsert, setIsParentDataInsert] = useState<boolean>(false);
	const [parentData, setParentData] = useState<ParentDataProps[]>([]);

	useEffect(() => {
		try {
			axios.get(`/v0/factories/${auth.factoryId}/share-processes`, {
				headers: auth.authorizationHeader
			}).then((res: any) => {
				if (res.data.length) {
					setParentData(res.data);
				} else {
					setParentData([]);
				}
				setIsParentDataInsert(false)
			})
		} catch (err) {
			console.log(err)
		}
	}, [auth, isParentDataInsert]);

	return (
		<>
			<Wrapper>
				<MyBread />
				<PageTitle>共有工程</PageTitle>
				<Parent data={parentData} setIsParentDataInsert={setIsParentDataInsert} />
			</Wrapper>
		</>
	)
}